// ÚNICAMENTE URL y publishable key públicas. No agregar claves secretas.
// Copia los valores desde Supabase → Project Settings / Connect.
export const environment = {
  supabaseUrl: 'https://vxdgievvrrdfvjigtrrs.supabase.co',
  supabasePublishableKey: 'sb_publishable_o-6aKYmqGXQfJOytXhAPEg_fGGJ6nkJ'
};
